<template>
    <div>
        <my-header title="登录/注册"/>
        <van-tabs class="login-wrap" v-model="active" color="#3EA1E8">
            <van-tab title="账号登录">
                <login-pwd/>
            </van-tab>
            <van-tab title="手机号登录">
                <login-phone/>
            </van-tab>
            <van-tab title="注册帐户">
                <register/>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
import LoginPwd from './login-pwd';
import LoginPhone from './login-phone'
import Register from "@/views/my/login/register";
import MyHeader from "@/components/myHeader";

export default {
    name: "login",
    components:{
        Register,MyHeader,
        LoginPwd,LoginPhone
    },
    data(){
        return{
            active:0
        }
    },
    created() {
        const token = localStorage.getItem('token')
        if(token){
            this.$router.replace('/my')
        }
    }
}
</script>

<style scoped>
.login-wrap{
    margin: 20vh auto 0 auto;
    width: 90vw;
}
</style>
